<template>
<div class="chapter">
<div class="inner_page">
<div id="container">
<img alt="Page 1" class="back" src="images/graphics_1.jpg"/>
<div class="text"><div style="position:absolute;-webkit-transform:matrix(1.000000, 0.0000, 0.0000, 1.000000, 0,0);width:738px"><div></div>
</div></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pg_1.vue?77ef2066